import React from "react";

import { PatientAgentLogo } from "~/assets";

export const NotFound = () => {
  return (
    <main className="flex h-screen flex-col items-center justify-center p-10">
      <div className="mb-10 w-full max-w-96">
        <img src={PatientAgentLogo} alt="logo" className="w-full" />
      </div>

      <p className="text-2xl">
        Looks like the page you are trying to access does not exist.
      </p>
    </main>
  );
};
